<template>
  <div class="inners">
    <!--{{ spaceSize }}-->
       <!-- {{isVipUser}} -->
    <!--        {{switchData}}-->
    <div class="left" ref="parentRef" :key="refreshCount">
      <div class="flex" @click="toEditUserInfo">
        <img
            width="20"
            height="20"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAU9JREFUOE+l1LsublEUxfEfDUoNEU8gOucREJcQicsLKE+JgkShJCFKEqXecU0kbi8g4gUkGrWecGTK2sm2823f3sx6rf8aY465Zov6NY597GC1eL2lJi9gB2hL9zawnGfUAY4l2BvmsYY+fIFWBWawdhxiGl24SdB1rITSKsBR/EMoe0Q/dvEX3bhO0CVsNQPmYZO4xwX+pFAWcYRhbGPhO2ARFvaiOnGJATyhN0Hn8FoGzGDvmEi9yofZgwd05GFlPRxJjS+DRTDR03g07H4qy14rKmwGi/mLlAN2nGAvZXM4iFOEsggg0stXU1jR8jlC4RCufgIrAiO5UNmK/zlgKIuexXCfYBZfbJZZbgSsBStTGEOaKYzBraSsUcpniG1SrAhq5jubZZbjj06lHmZnnrFXFVZ1OdRamdlgb6a/Wetyg8N3GfA2bZDfAm8/AIZIVWxiy9xbAAAAAElFTkSuQmCC"
        />
      </div>
      <div class="bottoms">
        <div class="avactor">
          <div>
            <el-avatar
                v-if="userInfo.avatar"
                :size="100"
                :src="userInfo.avatar"
            />
            <el-avatar v-else :size="100">
              <img :src="require('@/assets/default/avatar.png')"/>
            </el-avatar>
          </div>
          <div style="display: flex;justify-content: center;align-items: center">
            <span style="margin-right: 5px">{{ userInfo.userName }}</span>
            <span v-if="userInfo.sex===1" style="padding-top: 4px">
              <img style="width: 16px;height: 16px" :src="require('@/assets/usercenter/man_pc.png')"/>
            </span>
            <span v-else style="padding-top: 4px">
              <img style="width: 16px;height: 16px" :src="require('@/assets/usercenter/woman_pc.png')"/>
            </span>
          </div>
          <div>{{ userInfo.guid }}</div>
          <div
              style="width: 93%; margin: 20px auto; border-top: 1px solid #e8e8e8;"
          ></div>
        </div>
        <div class="set_tool">
          <div>
            <span>
              <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAutJREFUWEfdmD9IW0Ecx78XpSQPCg4qhrqIm3GoEmiXDBLcmimCShZxyJSKIYggCeqSTQ24dRGHGEISROimieCSFkQEiYODiwQlRpA2voSguXIPMxQ173fPpg39QfKG+97v+3l39+4fw2Nwzt+Uy2UvAE+tVrMxxt7Wy5rx5Jz/NJlMOQBRi8XyhTFWFT5M/Kmq+o5z/hXA+2aYE3IeM8Y+KYqSZ6JlVFX9/g9h6rzHiqJ8YKqq+jjn64S3aLqEMfZZAGU55x+b7kYwYIx9Y6VS6UezBzCBRZOIgc7u7u44tcLf0P0/QJVKBalUCnt7e7i4uIDZbMbg4CDGx8cxNDRkuDENtdDNzQ0CgQDOz8+fNZ6amsL09LQhKGkgzjl8Ph9OTk4aGoZCIYyOjkpDSQNls1nMz8/rGvX09CAej4MxbTEghzTQ2toatre3SQabm5vo6+sjaesiaaBgMIiDgwOSyerqKux2O0lrGGhlZQU7Ozskk42NDfT395O0hoFE64hW0ovOzk4kk0mYTCY96W/l0l1Wq9Xg9XpxdnbW0Ghubg4ul0sKRoilgUSlq6sr+P1+5PP5Zw3HxsYwMzMjDWMYSFQslUqIRqPY3d1FoVBAW1sbbDabNlM7HA5DMIaBHh4ecHp6isvLS5TLZVSrVbS3t2vjxWKxwGq1YmBgQIOUDakuEyCJRAJbW1u4vb1t6NXR0QGPxwPRfTJgZCCxmC4sLODw8FDqpcU8FA6HtcWXEmSgpaUlZDIZSs4nGqfTicXFRVJdEtDR0RFmZ2dJCV8SRSIRDA8P6+YgAS0vLyOdTusmaySgthIJyO124/r6+lVAXV1d2oZOL0hAIyMjEF/Ya0J8afv7+7opSECTk5Mvzsq6Do+C3t5ebbrQCxKQWCJisRhyuRyKxaI4euP+/l4cW57kFxsyMUGKn6Io6O7u1vbaExMT2oSpFyQgvSR/srz1Dootd5RuucuGlruOEQOypS6s6l9Iq1zp/QLezIWUqabIMQAAAABJRU5ErkJggg=="/>
            </span>
            <span>{{ userInfo.account }}</span>
          </div>
          <div>
            <span>
              <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAeNJREFUWEftmL1qAkEQx//TRO4glYKCLyCkSWXyEGnEStKIRQpJ/ADBZxAEPwIWKcQmWIlN3iGJVZqAPoCgoE2Ce5pmwi4RRC7eRjxzxW1xB7f/nfntMLs3u4SfxswnlmXdALgGcMbMp+s+N95E9AngHcCjYRgPRPQl/ZB8CCGizPwE4NwN5xo234joyjTNMcnICCFe/xFmzftmmuYFCSFumfleYxauS4joTgI9M/Ol6940HBDRiwT6cDuBNViURCY6LRYL1h1wDJ020Gq1wnA4hGVZf+IyDAOxWAyBQEBrnBbQbDZDNpvFZDLRMrotikQiaLVaCIVCjuO1gDqdDtrttq2xQqGAeDyu+gaDAer1uq0uk8kgnU4fBqjRaKDX6zka2yVIJpPI5/OONrQitAlUq9UQDocdDUvBdDpFsVhUWteAut0uotGoFtB4PEYqlfKBfo2WHyGnRPIj5EdoHYHNjdHfh+zyYjNC5XIZwWDQKX1U/3w+R6VScXen1iKxEbn2L9v2RURIJBLqc7/fB7N9AXo0IFkLVatVBVQqlVRNZNcOCrSrQJP51Gw2FUMul1N5Y9cOWqB5roSVM14ulxiNRt4o8vddWfuM895B0YtHaW9dNnjuOkYmnqcurNYrwStXet8BwLigBWlEtQAAAABJRU5ErkJggg=="/>
            </span>
            <span v-if="userInfo.phone!==''&& userInfo.phone!==null">
                          {{ userInfo.phone }}
                        </span>
            <span v-if="userInfo.phone!=='' && userInfo.phone!==null">
              <el-button link type="primary" @click="toCancelBindPhone"
              >{{ $t("common.goto.update") }}</el-button>
            </span>
            <span v-else><el-button type="primary"
                                    link
                                    @click="bindPhone">{{ $t("common.goto.bind") }}</el-button>
            </span>
          </div>
          <div>
            <span><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAe9JREFUWEftmL9rIkEUx78PJbgLFiJioY21zWETK+20SWNtK6liZ60o+BfYHbbWNtdo5w9I0kgaO8HKQkSEhJ2FoLxjJAsJl2SGcze3R9xit3jffd/PvHn7Y4bwcjDzhW3b1wDKANLMHHZiXlyJ6AnAHEDPMIyfRPQsfUiehBAJZv4F4IcX5ho5H4joyjTNFcnKCCHu/yGMw/tgmuYlCSFumLmjMQrPJURUlUC3zJz13E3DgIjuJNCj1w2swXKUyEYny7JY94av0J2BVFX+/yo0HA6xWq1UA9OKJxIJFAqFT7XKCuXzeTC70/dEhNFodBpQLpc7JgiHw8hm/+51tVgssFwuj3nG47E7QDJLuVxGpVJBIBDQmiIpmk6naLfbsCzLfSCZMZPJoNFoIBKJfAp1OBzQ7XbR6/Xe6FytkJM5Fouh1WohnU6/C7Xb7dBsNjGbzf6IewIkXYLBIKrVKkql0hvT+XyOer2OzWbzLqxnQI6bfIxrtRpCoRD6/T46nQ72+/2H0+k5kHROpVJIJpOYTCbKZv8SICXFK8EZSFWtc4W+X4WKxSJs21YNXCtuGAYGg8FpH9f1eo3tdqtlqBJFo1HE4/HTgFQmbseVP2huG6ry+Q/IdwtFPy6l/bXZ4LvtGNn1vtqwch5Dv2zp/QbXkD2golKThQAAAABJRU5ErkJggg=="
                alt=""/></span>
            <el-popover
                :content="userInfo.email"
                placement="top"
                :effect="'dark'"
            >
              <template #reference>
                 <span v-if="userInfo.email!==''&& userInfo.email!==null"
                       style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
              {{ userInfo.email }}
              </span>
              </template>
            </el-popover>
            <span v-if="userInfo.email!==''&& userInfo.email!==null">
              <el-button link type="primary" @click="toCancelBindEmail">{{ $t("common.goto.update") }}</el-button>
            </span>
            <span v-else>
            <el-button link type="primary" @click="toSetEmail"
            >{{ $t("common.goto.bind") }}
            </el-button
            >
            </span>
          </div>
          <div><span><img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAdtJREFUWEftWDFrwkAYfZ9DwUAREVwq6Ch26dYiuIku/QPavYstOrsLjoII0kmEOjn2F7i03XQogrNO4tLiRQrylQuNWLDJtRqbYjIkJN/Lfe/evbvkPsLnwcxHuq5fA7gCcMrMx2bMiSsRvQF4AXDv9/vviOhd5iF5EkKcMPMDgDMnkiu02SeiS03TJiSVEUI8/yEZk29f07RzEkLcMHNdoReOQ4joVhJ6ZOYLx7MpJCCiJ0no1WkDK3AxINLoNJ/PWfWFfeA8QnYqKylUr9fR7XbBbD26yWQS1WrVLqdlXIlQPp/HeDxWStTr9ZRw34E8Qnby/U+FcrkcJpOJ0blarYZwOLzq6GKxQKFQgK7rxjPpoVarhdFotML4fD5ks1mkUik7gaCk0DqheDyOQCDwhdBgMFjdS0LreDMQi8XQbrd3Q+ins2wTPhKJoNPpHAAhFQ9JhdLpNDKZDEyPhUKh3Sn0Gw8tl0tEo1GDkPTY4QyZnSvlLNurqT0PbRoSbx2yMupwOES5XMZsNrPzsxEvlUpoNpvGdF8/5DpUqVSQSCS2+0ErFouYTqdKZOxAwWAQjUZjO0J2SXYdV/ra7zqpVXvu2yi6cSvtrmKD68ox0mCuKliZjndLSe8DfgnNoOjBOnAAAAAASUVORK5CYII="/></span>{{
              userInfo.country
            }}
          </div>
          <div v-if="!isEnterpriseMainUser">
            <span><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAl1JREFUWEftmD2IGkEcxd+Ixg+MhQiCsbnSS5NCTRotxEqDnTa5K02VYKeglSJWB3IEmwg2cmJno2IhgoIkueYOJAjaaiFoY3AFlZswS5TYZPe43dwm3BQqzn/n/fbNm/0Ygl+NUvpsvV6/B/AOwEtK6fN9nxzfhJAfAL4DuNLr9Z8JIRumQ9gHx3EvKKV1AK/kEBcx5i0h5K3BYJgS5gzHcd8eEWbPe2swGF4TjuM+UEo/iTgL2UsIIR8Z0BdK6RvZ1UQIEEK+MqCl3AEWwcKXsKCT1WpFxR7wN+qegIRc/vccajabmM1mQicmqt9qtSIQCPyxVtAhr9crSkxMESEE3W5XOUCMpNfryQOkUqlwd3cnxpijGsmB7HY7MpkMTk5O0O/3kU6nsd1uRYNJDpTNZnF6eopGo4Hz83NcXl6iVqvxQNFoFDqd7ghuMpkc+mWZskKhAK1Wi3w+z8NUKhWUSiUegv02Go1HQIPBAKlU6vCfpA6xVXJxcQGXy3UQKBaLKJfLjzNlwWAQiUQC1WoV4/EYfr8fbrcbZ2dnmE6nMJvNYGH/vW02GyyXS3kcisfjcDqdiEQivIDNZuPhWMjb7Tbq9TpMJtMR0M3NDWKxmDxAyWQSHo+HX12ssQCzC2cul0Or1eId02g0R0CLxQLX19fyAIVCIYTDYfbcchDY7XY80Gg0EpUjSUMtSlGg6P8D8vl8YNMiRVOr1eh0Og+7lw2HQ8zncyl4YLFY4HA4HgYkCck9BhF8HrrHWJKUPgEJ2ai8F0Ulvkora7NBcdsxLGSK2rDap14pW3o/AcbBaqDlgsyyAAAAAElFTkSuQmCC"/></span>
            <span v-if="userInfo.realName==='' || userInfo.realName===null">
              <el-button type="info" text style="color: black !important;padding: 0px !important;">{{
                  $t("common.unauthorized")
                }}，</el-button>
              <el-button
                  style="margin-left: -8px"
                  link
                  type="primary"
                  @click="toCheckUser"
              >{{ $t("common.certified.to") }}
            </el-button></span>
            <span v-else>
              <span>{{ userInfo.realName }}</span>
              <el-button
                  link
                  type="primary"
                  @click="toCheckUserChange"
              >{{ $t("common.goto.update") }}
            </el-button>
              </span>
          </div>
          <div v-if="isEnterpriseMainUser"><span>
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAs9JREFUWEfdmEFIYlEUhv9LIGUOLVrFiC4CF81mduMia9FW3ZgKWiRF6kJ34aZNECFBkDBEOrRoM20SAxl0EUW7cVYFMWslGARXpfSMWtzhPMaBmKfvvje96TFnoYt3zvk/zz33PO9l+GWcc0u3240DiAJ4xzl/03tmxDdjrAPgO4DPIyMjnxhjj6TD6EOSpLec8y8A3hshLpDzijHmtVqtPxhVRpKkb68I0+O9slqtH5gkSSnO+UeBX2G4C2MsTUBfOeduw9UEBBhjNQJqG93AAiyyCzU6u7+/56IB/8Lv/wK6vLzE8fExrq+vaXRgYmICMzMzCIfDGBsb01VQ3RXK5/M4OjpSFB0fH8f29jZcLpdmKF1AJycn2N3dHShGUIeHh5orpRno4eEBgUAAnQ5N/sEWjUaRSCTU3J491wxUq9WQyWSEROx2e99l7ZdAM1CpVEIulxMCGhoawvn5Oc0XIX95FmmdQ9VqFdlsVkjAZrOhUqkI+facNAM1m015W4uYx+PB1taWiOtvH81AFLm5uYnT09OBQrRM+/v7mJqaMh6o3W4jnU6jXq/3FUsmk4hEIppgdPVQT4GadWNjQ1HQ4XCgUChgdHTUWKBWqwVq6rOzMzQajYFiFosFbrcbc3Nz8uuEdpyICfcQzZ/19XU8PT2J5H3mQ31Eo2J4eFg1VhhoYWEBNzc3iglpAFI1isViX8G1tTX4/f6XA5qdnQXnyn+dVlZWsLS0BJ/Ph7u7O0XRUCiEVCr1ckDUB/1sdXUVi4uLcgVub28V3YLBoLwz1Ux4yQYBeb1exONxzM/P4/FRPl79YS8ORKI0f/Ta8vIyYrGYarhwhXZ2dlAul1UTKjnQlj84OMDk5KRqvDBQt9vF3t4eLi4uhCtFrw+n0ykv5/T0tCrMX01qoew6nIQrpCO3rhDzHRTNeJQ212WD6a5jqPNMdWHV2wpmudL7CUnNaqAClQ7nAAAAAElFTkSuQmCC"/>
          </span>
            <span>{{ userInfo.account }}</span>
          </div>
        </div>
        <!-- <div
            style="width: 80%; margin: 20px auto; border: 1px solid #e8e8e8;"
        ></div> -->
        <div class="userInfo_message" v-loading="leftLoading">
          <!-- 系统工位：只有个人账号才显示 -->
          <div class="message_info_item" v-if="isNormalUser" @click="goToStation">
            <div class="items">
              <div class="left_text">
                <span><img src="@/assets/q1.png"/></span><span class="texts">{{ $t('common.seat') }}</span>
              </div>
              <div class="right_text">
                <span>
                  {{ mailWorkPosition?.freePosition }}/<span style="color: var(--el-color-danger);">
                    {{ mailWorkPosition?.totalPosition }} {{ $t('common_ph22') }}
                  </span>
                </span>
                <el-icon>
                  <ArrowRightBold/>
                </el-icon>
              </div>
            </div>
          </div>

          <div class="message_info_item" @click="handleStorageClick">
            <div class="items">
              <div class="left_text">
                <span><img src="@/assets/q2.png"></span><span class="texts">{{ $t('common.space') }}</span>
              </div>
              <div class="right_text">
                <span>
                  {{ spaceSizeFormat(spaceSize?.freeLocation || 0, false) }}/<span style="color: var(--el-color-danger);">{{
                    spaceSizeFormat(spaceSize?.effectiveLocation || 0)
                  }}</span>
                </span>
                <el-icon>
                  <ArrowRightBold/>
                </el-icon>
              </div>
            </div>
          </div>

          <div class="message_info_item" @click="handleEdmClick">
            <div class="items">
              <div class="left_text">
                <span><img src="@/assets/edm.png" style="width: 16px;height: 16px;"></span><span
                    class="texts">{{ $t('userinfo.vip.edm') }}</span>
              </div>
              <div class="right_text">
                <span>{{ userDataInformation?.freeEdmNum ? userDataInformation?.freeEdmNum : 0 }}/<span
                    style="color: var(--el-color-danger);">{{
                    $t('userinfo.edm.number', {number: userDataInformation?.edmTotalNum ? userDataInformation?.edmTotalNum : 0})
                  }}</span></span>
                <el-icon>
                  <ArrowRightBold/>
                </el-icon>
              </div>
            </div>
          </div>

          <div class="message_info_item" @click="handleAiClick">
            <div class="items">
              <div class="left_text">
                <span><img src="@/assets/AI.png" style="width: 16px;height: 16px;"></span><span
                    class="texts">{{ $t('userinfo.vip.AI') }}</span>
              </div>
              <div class="right_text">
                <span>{{ userDataInformation?.freeAiNum ? userDataInformation?.freeAiNum : 0 }}/<span
                    style="color: var(--el-color-danger);">{{
                    $t('userinfo.AI.number', {number: userDataInformation?.totalAiNum ? userDataInformation?.totalAiNum : 0})
                  }}</span></span>
                <el-icon>
                  <ArrowRightBold/>
                </el-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right" v-if="isNormalUser">
      <div class="titles" style="margin-bottom: 20px">{{ $t("common.account.info") }}</div>
      <!-- vip 信息 -->
      <!-- <CheckVip :memberType="memberType"></CheckVip> -->
      <!-- 是否是 vip vip 的单会员信息组件 -->
  <div class="line-text">{{ $t('common.exclusive') }}</div>
      <VipMemberInfo
        :isVip="isVipUser"
        :expireDate="userInfo?.vipExpireDate"
        :price="vipUpsellPrice"
        @action="handleVipAction"
      />
      <!-- <div style="display: flex;justify-content: space-between">
        <VipTab :memberType="memberType"></VipTab>
      </div> -->
      <div class="line-text">
        {{ $t('userinfo.vip.server.project') }}
      </div>
       <div class="des_user_blank">{{ $t('userinfo.vip.server.project.desc') }}</div>
      <div style="display: flex;justify-content: space-between">
        <VipProduct @openInvite="handleOpenInviteDialog"></VipProduct>
      </div>
    </div>
    <div class="right" v-else>
      <el-tabs v-model="activeName" class="demo-tabs">
        <el-tab-pane :label="$t('common.space')" name="1" lazy>
          <Echarts :show-detail-button="false"></Echarts>
        </el-tab-pane>
        <el-tab-pane :label="$t('account.tab.bar.edm')" name="2" lazy>
          <index-edm :left-width="450" :show-detail-button="false"></index-edm>
        </el-tab-pane>
        <el-tab-pane :label="$t('userinfo.vip.AI')" name="3" lazy>
          <index-a-i :left-width="450" :show-detail-button="false"></index-a-i>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
  <!-- <div class="invite-test-fixed">
    <el-button type="primary" @click="inviteDialogVisible = true">测试-邀请好友弹窗</el-button>
  </div>
  <div class="resource-detail-test-fixed">
    <el-button type="primary" @click="resourceDetailVisible = true">测试-获取资源明细</el-button>
  </div> -->
  <unBindPhone v-if="visitable" v-model="visitable" @close="close" @refresh="refresh"></unBindPhone>
  <unBindEmail v-if="visitableEmail" v-model="visitableEmail" @close="closeEmail" @refresh="refreshEmail"></unBindEmail>
  <InviteFriendDialog
      v-model="inviteDialogVisible"
      :user-info="userInfo"
      :resource-options="inviteResourceOptions"
      :default-resource="inviteDefaultResource"
      :on-generate="handleGenerateInviteLink"
      :on-send-email="handleSendInviteEmail"
      @generate="handleGenerateInviteLink"
      @send-email="handleSendInviteEmail"
  />
  <ResourceDetailDialog v-model="resourceDetailVisible" :use-invite-list="true" />
</template>

<script setup>
import {onMounted, computed, ref, nextTick, watch} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import Echarts from "@/views/UserCenter/StoreDetails/Echarts.vue";
import unBindPhone from "@/components/DiaPops/unBindPhone/index.vue"
import unBindEmail from "@/components/DiaPops/unBindEmail/index.vue"
import InviteFriendDialog from "@/components/InviteFriendDialog/index.vue"
import ResourceDetailDialog from "@/components/ResourceDetailDialog/index.vue"
import VipProduct from "@/views/UserCenter/component/VipProduct.vue";
import VipMemberInfo from "@/views/UserCenter/component/VipMemberInfo.vue";
import {spaceSizeFormat} from "@/utils/file";
import IndexEdm from "@/views/UserCenter/EdmDetails/component/indexEdm.vue";
import IndexAI from "@/views/UserCenter/AIDetails/component/indexAI.vue";
import {i18n} from "@/lang";
import {ArrowRightBold} from "@element-plus/icons-vue";

const route = useRoute()
const router = useRouter();
const store = useStore()
const activeName = ref('1')
const userInfo = computed(() => store.state.user.userInfo)
const isEnterpriseMainUser = computed(() => store.getters["user/isEnterpriseMainUser"])
// 正常普通用户
const isNormalUser = computed(() => store.getters["user/isNormalUser"])
// 判断账户类型：1=个人账号 2=企业主账号 3=企业子账号
const accountType = computed(() => store.state.user.userInfo.accountType)
// 是否是企业账号（企业主账号或企业子账号）
const isEnterpriseAccount = computed(() => accountType.value === 2 || accountType.value === 3)

const mailWorkPosition = computed(() => store.state.user.mailWorkPosition)
const spaceSize = computed(() => store.state.cloud.spaceSize)

const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const companyInformation = computed(() => store.state.user.companyInformation)

const isVipUser = computed(() => store.getters['user/isVipUser'])

const vipUpsellPrice = computed(() => {
  const n = Number(store.state.buystorage.vipUpsellPrice ?? 0)
  return Number.isFinite(n) ? n : 0
})
// 会员选择 主要 ！！！
const memberType = computed(() => {
      // isVip 1,2,3
      // product 6,7,8
      if (isVipUser.value) {
        return userInfo.value.isVip * 1 + 5
      } else {
        return 5
      }
    }
)

const allUserVip = computed(() => store.state.buystorage.allUserVip)

const handleVipAction = (val) => {
  const vipList = allUserVip.value || []

  if (isVipUser.value) {
    const current = vipList.find(v => v.productSort === memberType.value)
    const query = {
      ...(current?.id ? {indexId: current.id} : {}),
      ...(current?.productSort ? {productSort: current.productSort} : {productSort: memberType.value}),
    }
    if (val) {
      query.indexId = 9
    }
    router.push({
      path: '/personal/buystorage',
      query: query
    })
    return
  }

  const defaultVip = vipList.find(v => v.productSort >= 6 && v.productSort <= 8) || vipList[0]
  const query = {
    ...(defaultVip?.id ? {indexId: defaultVip.id} : {}),
    productSort: defaultVip?.productSort || 6,
  }
  if (val) {
    query.indexId = 9
  }
  router.push({
    path: '/personal/buystorage',
    query: query
  })
}
// 判断是企业 还是 个人
// const switchData = computed(() => {
//   console.log(userDataInformation.value, companyInformation.value,'dddd')
//   return isNormalUser.value ? userDataInformation.value : companyInformation.value
// })

const messageInfo = computed(() => {
  const targetData = [
    {
      id: 1,
      name: i18n.global.t('common.seat'),
      sum: mailWorkPosition.value?.freePosition,
      allCount: mailWorkPosition.value?.totalPosition,
      units: i18n.global.t('common.ph22')
    },
    {
      id: 2,
      name: i18n.global.t('common.space'),
      sum: spaceSize.value?.freeLocation || 0,
      allCount: spaceSize.value?.effectiveLocation || 0,
      units: ""
    },
    {
      id: 3,
      name: i18n.global.t('userinfo.vip.edm'),
      sum: userDataInformation.value?.freeEdmNum ? userDataInformation.value?.freeEdmNum : 0,
      allCount: userDataInformation.value?.edmTotalNum ? userDataInformation.value?.edmTotalNum : 0,
      units: i18n.global.t('common.ph23')
    },
    {
      id: 4,
      name: i18n.global.t('userinfo.vip.AI'),
      sum: userDataInformation.value?.freeAiNum ? userDataInformation.value?.freeAiNum : 0,
      allCount: userDataInformation.value?.totalAiNum ? userDataInformation.value?.totalAiNum : 0,
      units: i18n.global.t('common_ph24')
    }
  ]
  if (isNormalUser.value) {
    return targetData
  } else {
    const newTargetData = targetData.slice(1);
    return newTargetData
  }
})

const goToStation = () => {
  router.push('/personal/station')
}

const handleStorageClick = () => {
  // 如果是企业账号，切换右侧 tab
  if (isEnterpriseAccount.value) {
    activeName.value = '1'
    return
  }
  // 个人账号跳转路由
  router.push('/personal/storeDetails')
}

const handleEdmClick = () => {
  // 如果是企业账号，切换右侧 tab
  if (isEnterpriseAccount.value) {
    activeName.value = '2'
    return
  }
  // 个人账号跳转路由
  router.push('/personal/edmDetails')
}

const handleAiClick = () => {
  // 如果是企业账号，切换右侧 tab
  if (isEnterpriseAccount.value) {
    activeName.value = '3'
    return
  }
  // 个人账号跳转路由
  router.push('/personal/aiDetails')
}

const goToStoreDetails = () => {
  router.push('/personal/storeDetails')
}

const goToStoreEDM = () => {
  router.push('/personal/edmDetails')
}

const goToStoreAI = () => {
  router.push('/personal/aiDetails')
}

const toEditUserInfo = () => {
      router.push({path: "/personal/editInfo", query: {isQ: 0}});
    }
;

// 绑定邮箱
const toSetEmail = () => {
  router.push({path: "/personal/setemail", query: {isChange: 2}});
};

// 修改绑定的邮箱
const visitableEmail = ref(false)
const closeEmail = () => {
  visitableEmail.value = false
}
const toCancelBindEmail = () => {
  visitableEmail.value = true
  // router.push({path: "/personal/setemail", query: {isChange: 1}});
}
const refreshEmail = () => {

}

const visitable = ref(false)
const close = () => {
  visitable.value = false;
}

const inviteDialogVisible = ref(false)
const inviteDefaultResource = ref('')
const inviteResourceOptions = computed(() => {
  const list = Array.isArray(store.state.buystorage?.allProductList) ? store.state.buystorage.allProductList : []
  return list.map((it) => ({
    label: `${getProductLabel(it)} ${getProductUnitText(it)}`.trim(),
    value: String(it?.id ?? '')
  })).filter(it => it.value)
})

const getProductLabel = (item) => {
  const sort = Number(item?.productSort)
  if (sort === 1) return i18n.global.t('userinfo.vip.service.1')
  if (sort === 2) return i18n.global.t('userinfo.vip.service.2')
  if (sort === 3) return i18n.global.t('userinfo.vip.service.3')
  if (sort === 4) return i18n.global.t('userinfo.vip.service.4')
  return ''
}

const getProductUnitText = (item) => {
  const sort = Number(item?.productSort)
  if (sort === 1) return i18n.global.t('common.text.per.station.year', {number: item?.productNum})
  if (sort === 2) return i18n.global.t('common.text.per.GB.year', {number: spaceSizeFormat(item?.productNum, false)})
  if (sort === 3) return i18n.global.t('common.text.per.feng.year', {number: item?.productNum})
  if (sort === 4) return i18n.global.t('common.text.per.year', {number: item?.productNum})
  return ''
}

const handleOpenInviteDialog = (item) => {
  inviteDefaultResource.value = String(item?.id ?? '')
  inviteDialogVisible.value = true
}
const handleGenerateInviteLink = async () => {
  const invitedCode = String(userInfo.value?.guid ?? '')
  const selectedId = String(inviteDefaultResource.value ?? '')
  const list = Array.isArray(store.state.buystorage?.allProductList) ? store.state.buystorage.allProductList : []
  const selected = list.find(it => String(it?.id ?? '') === selectedId)
  const invitedProductId = selected?.productSort != null ? String(selected.productSort) : ''
  const base = `${window.location.origin}/register`
  const params = new URLSearchParams()
  if (invitedCode) params.set('invitedCode', invitedCode)
  if (invitedProductId) params.set('invitedProductId', invitedProductId)
  const qs = params.toString()
  return qs ? `${base}?${qs}` : base
}

const handleSendInviteEmail = async ({ link }) => {
  console.log('send invite email with link:', link)
}

const resourceDetailVisible = ref(false)
const resourceDetailList = ref([
  { time: '2021-11-11 08:08:08', resource: '工位1个/1年' },
  { time: '2021-11-11 08:08:08', resource: '空间存储2GB/1年' },
  { time: '2021-11-11 08:08:08', resource: '营销邮件2000封/1年' },
  { time: '2021-11-11 08:08:08', resource: '智能点数1000点/1年' }
])
// 父组件刷新的次数
const refreshCount = ref(0);
const refresh = () => {
  nextTick(() => {
    refreshCount.value = Math.random();
  })
}
// 取消绑定手机号
const toCancelBindPhone = () => {
  // ElMessage.warning("您需要先解绑手机号")
  // setTimeout(() => {
  //   router.push({path: '/personal/security'})
  // }, 1500)
  // router.push({path: "/personal/setphone", query: {isChange: 1}});
  visitable.value = true
}

const bindPhone = () => {
  router.push({path: "/personal/setphone", query: {isChange: 2}});
}
const toCheckUser = () => {
  router.push({path: "/personal/realName", query: {isChange: 2}});
};
const toCheckUserChange = () => {
  router.push({path: "/personal/realName", query: {isChange: 1}});
}

// ---------------------
// 详情
const clickTargetTo = () => {
  router.push('/personal/station')
}
const clickTargetToSave = () => {
  router.push('/personal/storeDetails')
}
const clickTargetToFlow = () => {
  router.push('/personal/flowDetails')
}

const leftLoading = ref(false)

watch(
    () => route.query.active,
    (newVal) => {
      if (newVal) {
        activeName.value = newVal
      }
    },
    {immediate: true} // 👈 首次也会执行
)

onMounted(async () => {
  try {
    leftLoading.value = true
    if (store.state.buystorage.vipUpsellPrice === null || store.state.buystorage.vipUpsellPrice === undefined) {
      await store.dispatch('buystorage/getVipUpsellPrice')
    }
    await store.dispatch("cloud/queryByUserIdApis")
    leftLoading.value = false
  } catch (e) {
    leftLoading.value = false
  }
})
// -------------
</script>

<style lang="less" scoped>
@import "./less/Basic.less";

.invite-test-fixed {
  position: fixed;
  right: 20px;
  top: 120px;
  z-index: 999;
}

.resource-detail-test-fixed {
  position: fixed;
  right: 20px;
  top: 170px;
  z-index: 999;
}

.right {
  min-height: 820px !important;
}

:deep(.el-avatar) {
  background: #f3f3f3 !important;
}

:deep(.el-tabs__item) {
  margin-right: 30px;
  padding-top: 29px;
  padding-bottom: 29px;
  cursor: pointer;
  font-size: 18px;
}

:deep(.el-button) {
  font-size: 14px !important;
}

:deep(.el-table .cell) {
  font-size: 14px !important;
  font-weight: normal !important;
}

:deep(.el-progress-bar__inner) {
  border-radius: 0px !important;
}

:deep(.el-progress-bar__outer) {
  border-radius: 0px !important;
}

.font {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.line-text {
  width: 350px;
  display: flex;
  align-items: center;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #8B4127;
  margin: 20px auto 10px auto;
}

.line-text::before,
.line-text::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: #FCDEB9;
}

.line-text::before {
  margin-right: 8px;
}

.line-text::after {
  margin-left: 8px;
}

.left_box {
  div {
    margin-bottom: 10px !important;
  }
}
.des_user_blank{
  width: 100%;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #9B9B9B;
  margin-bottom: 10px;
}
</style>
